export enum LorenConditionRelation {
    ALL_ARE_MET = 'AND',
    ANY_IS_MET = 'OR'
}
